import { getBossEbooks } from '@/api/sound'

export default {
  data () { return { monthly: [] } },
  watch: {
    isDetailRoute () { this.refreshMonthly() }
  },
  methods: {
    async refreshMonthly () {
      clearTimeout(this.monthlyPollTimer)
      if (this.monthlyDisposed || this.isDetailRoute || document.hidden || this.monthlyRequestPending) return
      this.monthlyRequestPending = true
      try {
        // Recheck server publication rules; never publish using the device clock.
        const response = await getBossEbooks({ _t: Date.now() })
        if (!this.monthlyDisposed && !this.isDetailRoute && !document.hidden) {
          this.monthly = response.data
        }
      } catch (error) {
        // Keep the last successful list during a temporary connection failure.
      } finally {
        this.monthlyRequestPending = false
        if (!this.monthlyDisposed && !this.isDetailRoute && !document.hidden) {
          this.monthlyPollTimer = setTimeout(() => this.refreshMonthly(), 15000)
        }
      }
    }
  },
  mounted () {
    this.monthlyDisposed = false
    document.addEventListener('visibilitychange', this.refreshMonthly)
    window.addEventListener('online', this.refreshMonthly)
    this.refreshMonthly()
  },
  beforeDestroy () {
    this.monthlyDisposed = true
    clearTimeout(this.monthlyPollTimer)
    document.removeEventListener('visibilitychange', this.refreshMonthly)
    window.removeEventListener('online', this.refreshMonthly)
  }
}
